import React from 'react';
import { FaHeart, FaStar, FaRegHeart } from 'react-icons/fa';
import styles from './SponsorsPage.module.css';

// Reusable Header and Footer should be imported from your layout
// import Header from '../components/Header'; 
// import Footer from '../components/Footer';

const sponsorsData = [
  {
    id: 1,
    name: "Apex Constructions",
    type: "Top Rated Builder",
    rating: 5.0,
    reviews: 120,
    image: "https://images.pexels.com/photos/2219024/pexels-photo-2219024.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 2,
    name: "Terra Firma Earthworks",
    type: "Top Rated Earthworks",
    rating: 5.0,
    reviews: 150,
    // Changed to Excavator/Construction site image
    image: "https://images.pexels.com/photos/159358/construction-site-build-construction-work-159358.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 3,
    name: "Solid Rock Masonry",
    type: "Top Rated Mason",
    rating: 5.0,
    reviews: 110,
    image: "https://images.pexels.com/photos/257352/pexels-photo-257352.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 4,
    name: "Pinnacle Painting",
    type: "Top Rated Painter",
    rating: 4.9,
    reviews: 105,
    image: "https://images.pexels.com/photos/259988/pexels-photo-259988.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 5,
    name: "Precision Builders",
    type: "Top Rated Builder",
    rating: 4.9,
    reviews: 88,
    image: "https://images.pexels.com/photos/157811/pexels-photo-157811.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 6,
    name: "Summit Scaffolding",
    type: "Top Rated Scaffolder",
    rating: 4.9,
    reviews: 92,
    image: "https://images.pexels.com/photos/585419/pexels-photo-585419.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 7,
    name: "Keystone Tradies",
    type: "Top Rated Electrician",
    rating: 4.8,
    reviews: 75,
    image: "https://images.pexels.com/photos/1216589/pexels-photo-1216589.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 8,
    name: "BlueSky Roofing",
    type: "Top Rated Roofer",
    rating: 4.7,
    reviews: 65,
    // Changed to Roof image
    image: "https://images.pexels.com/photos/936611/pexels-photo-936611.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 9,
    name: "Evergreen Landscaping",
    type: "Top Rated Landscaper",
    rating: 5.0,
    reviews: 95,
    // Changed to Garden/Landscaping image
    image: "https://images.pexels.com/photos/1409999/pexels-photo-1409999.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 10,
    name: "Volt Electrical",
    type: "Top Rated Electrician",
    rating: 4.9,
    reviews: 130,
    image: "https://images.pexels.com/photos/834892/pexels-photo-834892.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 11,
    name: "Aqua Flow Plumbing",
    type: "Top Rated Plumber",
    rating: 4.8,
    reviews: 115,
    image: "https://images.pexels.com/photos/3992870/pexels-photo-3992870.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
  {
    id: 12,
    name: "Ironclad Welding",
    type: "Top Rated Welder",
    rating: 5.0,
    reviews: 82,
    // Changed to Welding image
    image: "https://images.pexels.com/photos/2396668/pexels-photo-2396668.jpeg?auto=compress&cs=tinysrgb&w=800"
  },
];

const SponsorsPage = () => {
  return (
    <div className={styles.pageWrapper}>
      <div className={styles.container}>
        
        <header className={styles.header}>
            <h1 className={styles.title}>
                Our <span className={styles.highlightGold}>Premier Partners</span>
            </h1>
            <p className={styles.subtitle}>
                Explore our most trusted construction team professionals. These partners have demonstrated excellence, reliability, and quality craftsmanship.
            </p>
        </header>

        <main className={styles.grid}>
            {sponsorsData.map((sponsor) => (
                <a href={`/business/${sponsor.id}`} key={sponsor.id} className={styles.card}>
                    <div className={styles.imageWrapper}>
                        <img 
                            src={sponsor.image} 
                            alt={sponsor.name} 
                            className={styles.image} 
                            loading="lazy" 
                        />
                        <button 
                            className={styles.saveBtn} 
                            onClick={(e) => { e.preventDefault(); /* Add save logic */ }}
                            title="Save Business"
                        >
                            <FaRegHeart />
                        </button>
                    </div>
                    
                    <div className={styles.content}>
                        <h3 className={styles.businessName}>{sponsor.name}</h3>
                        <span className={styles.businessType}>{sponsor.type}</span>
                        
                        <div className={styles.ratingRow}>
                            <div className={styles.stars}>
                                <FaStar />
                            </div>
                            <span>{sponsor.rating}</span>
                            <span className={styles.reviewCount}>({sponsor.reviews} Reviews)</span>
                        </div>
                    </div>
                </a>
            ))}
        </main>

      </div>
    </div>
  );
};

export default SponsorsPage;